import { EDITOR_MODE, useEditorStateSelector } from "@pathwright/blocks-engine"
import { serifStyles } from "@pathwright/blocks/src/ui/typography"
import { Content } from "@pathwright/ui/src/components/content/Content"
import { useKatex } from "@pathwright/utils/src/katex/useKatex"
import React, { useRef } from "react"
import styled from "styled-components"
import { interpolateVariables } from "../utils/variables"

export const SubTextWrapper = styled.div`
  margin-top: 10px;
  ul {
    margin: 0px;
  }

  ul li {
    list-style-type: none;
  }
  ol li:not(.ql-direction-rtl),
  ul li:not(.ql-direction-rtl) {
    padding-left: 0;
  }
  // Hacky - accounts for padding on ol/ul element that's present only in Preview mode.
  ol [class^="ql-indent"],
  ul [class^="ql-indent"] {
    margin-left: -1.5em;
  }
  ul li:before {
    content: "\\2022";
    margin-left: -1.5em;
    margin-right: 0.3em;
    text-align: right;
    display: inline-block;
    white-space: nowrap;
    width: 1.2em;
  }
  p,
  li {
    color: #2a2e33;
    font-weight: 400;
    line-height: 1.3em;
    ${serifStyles({ size: 20 })}
    margin: 0px;
  }
  > span:not(.katex),
  p > span:not(.katex),
  li > span:not(.katex) {
    ${serifStyles({ size: 16 })}
    font-weight: 500;
    line-height: 1.2em;
    color: #666;
  }

  // This causes Katex to look glitched. We removed the same code from BlockText.js
  // so we'll assume it's safe to remove here too (probably just missed removing it here).
  // .katex,
  // .katex span {
  //   font-size: 100%;
  //   white-space: pre-wrap !important;
  // }
`

const SubText = (props) => {
  const { html, text, templateContext, style, mode } = props
  const isEditMode = useEditorStateSelector(
    (state) => !!state?.mode && state.mode === EDITOR_MODE.EDIT
  )

  let content = html ? html : text

  if (templateContext) {
    try {
      content = interpolateVariables(content, templateContext)
    } catch (error) {
      console.error("Error parsing template: ", error.toString())
    }
  }

  const subtextRef = useRef(null)

  useKatex(subtextRef, { enabled: !isEditMode, contentKey: content })

  if (html) {
    return (
      <Content.Text>
        <SubTextWrapper
          ref={subtextRef}
          className={`SubText SubText--${(mode || "view").toLowerCase()}`}
          dangerouslySetInnerHTML={{ __html: content }}
          style={style}
        />
      </Content.Text>
    )
  }

  return <div className="SubText">{content}</div>
}

export default SubText
